import angular from "angular";
import ngResource from "angular-resource";
import Assert from "tbAssert";

import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

import ElectionFactoryModule from "../models/factories/ElectionFactory";
import OfficeFactoryModule from "../models/factories/OfficeFactory";


function ElectionDataServiceFactory($resource, ElectionFactory, OfficeFactory, TbAppConfigDataService) {

    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");
    Assert.StrictAssert(ElectionFactory != null, "Assertion Failure: Missing Election Factory Service Dependency");
    Assert.StrictAssert(OfficeFactory != null, "Assertion Failure: Missing Office Factory Service Dependency");

    const tbServerBaseUrl = TbAppConfigDataService.tbServerBaseUrl;

    const tbElectionDataApiUrl = tbServerBaseUrl + "/api/elections/:electionId";
    const tbElectionDetailsDataApiUrl = tbServerBaseUrl + "/api/elections/:electionId/details";
    const tbElectionDataApiParams = { electionId: "@electionId" };

    const tbElectionSubscribersApiUrl = tbServerBaseUrl + "/api/elections/:electionId/subscribers/:recipientId";
    const tbElectionSubscribersApiParams = {electionId: "@electionId", recipientId: "@recipientId"};

    const tbElectionCandidateApiUrl = tbServerBaseUrl + "/api/elections/:electionId/candidates/:trackingTargetId";
    const tbElectionCandidateApiParams = { electionId: "@electionId", trackingTargetId: "@trackingTargetId" };

    const electionDataResponseInterceptor = (serverResponse) => {
        let serverElectionObj =
            ElectionFactory.FromServerElection(
                serverResponse.data,
                OfficeFactory.FromServerOffice
            );

        angular.extend(serverResponse.resource, {
            result: serverElectionObj
        });

        return serverResponse.resource;
    };

    return $resource(
        tbElectionDetailsDataApiUrl,
        tbElectionDataApiParams,
        {
            get: {
                url: tbElectionDetailsDataApiUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            },
            getCore: {
                url: tbElectionDataApiUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            },
            addSubscription: {
                method: "PUT",
                url: tbElectionSubscribersApiUrl,
                params: tbElectionSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            },
            removeSubscription: {
                method: "DELETE",
                url: tbElectionSubscribersApiUrl,
                params: tbElectionSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            },
            addCandidate: {
                method: "PUT",
                url: tbElectionCandidateApiUrl,
                params: tbElectionCandidateApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            },
            removeCandidate: {
                method: "DELETE",
                url: tbElectionCandidateApiUrl,
                params: tbElectionCandidateApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            },
            updateCandidate: {
                method: "PATCH",
                url: tbElectionCandidateApiUrl,
                params: tbElectionCandidateApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: electionDataResponseInterceptor
                }
            }
        }
    );
}

ElectionDataServiceFactory.$inject = [ "$resource", "ElectionFactory", "OfficeFactory", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.election-data-service",[
        ngResource,
        ElectionFactoryModule,
        OfficeFactoryModule,
        TbAppConfigDataServiceModule
    ])
    .factory("ElectionData", ElectionDataServiceFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/ElectionDataService.js
// module id = DdKq
// module chunks = 1